<template>
  <div class="exportWrap">
    <el-button
      type="button"
      @click="handleDownload"
      class="el-button el-button--primary el-button--small"
      :loading="btnLoading"
    >
      <span>导出</span>
    </el-button>
  </div>
</template>
<script>
import { handleExport } from '@/utils/blob-download';
import { mapState, mapActions } from 'vuex';
export default {
  name: 'LyExportButton',
  props: {
    link: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState(['loading']),
    btnLoading() {
      return this.loading.download;
    }
  },
  methods: {
    ...mapActions(['SetLoading', 'CancalLoading']),
    handleDownload() {
      this.SetLoading({ download: true });
      handleExport({
        url: this.link,
        callback: () => {
          this.CancalLoading();
        }
      });
    }
  }
};
</script>
<style lang="less">
.el-button + .exportWrap {
  margin-left: 10px;
}
.exportWrap {
  display: inline;
}
</style>



// WEBPACK FOOTER //
// src/components/export-button/index.vue